import styled from 'styled-components';

const LabelRulesStyled = styled.div`
  .file_name {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    background-color: ${(props) =>
      props.queryType === 'detail' ? '#fff' : '#e0e0e0'};
    border-radius: 16px;
    padding-left: 12px;
    padding-right: 12px;
  }
  .title {
    font-size: 16px;
    font-weight: 400;
    color: #212121;
    line-height: 22px;
    margin-top: 32px;
    padding-bottom: 24px;
  }
  .line {
    display: flex;
    align-items: flex-end;
    padding-left: 16px;
    .left {
      display: flex;
    }
  }
  /* .ant-cascader-picker-label {
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  } */
  .ant-cascader-picker-label {
    color: ${(props) => props.color} !important;
  }
`;

export default LabelRulesStyled;
